<!-- 对话框 -->
<template>
  <div class="service-dialog">
    <van-dialog
      v-model="showDialog"
      :title="title"
      :lock-scroll="false"
      :close-on-click-overlay="true"
      @close="closeDialog"
      v-backFn="{ show: showDialog, closeFn: 'closeDialog' }"
    >
      <div class="dialog-content">
        <slot></slot>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: 'serviceDialog',
  props: {
    title: {
      type: String,
      default: 'vivo服务'
    }
  },
  data() {
    return {
      showDialog: false
    }
  },
  methods: {
    // 阻止页面滑动
    preventPageScroll() {
      if (this.isPrevent || document.body.classList.contains('isPrevent')) {
        return
      }

      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      this.marginTop = document.body.style.marginTop
      this.height = document.body.style.height
      this.overflow = document.body.style.overflow
      Object.assign(document.body.style, {
        marginTop: -this.scrollTop + 'px',
        height: window.innerHeight + this.scrollTop + 'px',
        overflow: 'hidden'
      })
      document.body.classList.add('isPrevent')
      this.isPrevent = true
    },
    // 恢复页面滑动
    restorePageScroll() {
      if (!this.isPrevent) {
        return
      }

      Object.assign(document.body.style, {
        marginTop: this.marginTop,
        height: this.height,
        overflow: this.overflow
      })
      document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop
      document.body.classList.remove('isPrevent')
      this.isPrevent = false
    },
    openDialog() {
      this.preventPageScroll()
      this.showDialog = true
    },
    closeDialog() {
      this.restorePageScroll()
      this.showDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.service-dialog {
  ::v-deep .van-overlay {
    background-color: rgba(0, 0, 0, 0.3) !important;
  }

  ::v-deep .van-dialog {
    width: 328px;
    border-radius: 18px;
    padding: 27px 24px;
    box-sizing: border-box;
    max-height: 66.66%;
  }

  ::v-deep .van-dialog__header {
    color: #333;
    padding-top: 26px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;
    padding-top: 0;
  }

  ::v-deep .van-dialog__footer {
    width: 180px;
    margin: 0 auto;

    .van-dialog__confirm {
      color: #fff;
      font-size: 16px;
      font-weight: 500;
      height: 46px;
      border-radius: 82px;
      width: 100%;
      display: flex;
      justify-content: center;

      .van-button__content {
        height: 46px;
        width: 180px;
        border-radius: 82px;
        background-color: #415fff;

        .vivo-dark-mode & {
          background-color: #3a56e6;
        }
      }
    }
  }

  ::v-deep .van-hairline--top {
    &::after {
      border-top-width: 0px;
    }
  }

  .dialog-content {
    padding: 18px 0 27px;
  }
}
</style>
